<template>
  <div>
    <b-card title="One of the Leading Architecture Firms in Dubai 🚀">
      <b-card-text>
        <p>Our commercial &amp; residential interior designers Dubai handpick a range of items especially for you. We collaborate with a diverse group of coveted brands, up-and-coming retailers, and local artisans to ensure that each design is customized to your personal style, needs, and budget. Other than that, we have expertise in landscape designs and fit out solutions.<br>Every Decorious member becomes an essential component of the partnership process in order to provide an authentic style and home identity for our clients' residential spaces. Associates are dedicated to providing turnkey design services to a high-end, luxury clientele.<br><br><b>Our Features</b><br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; •&nbsp;&nbsp; &nbsp;Expertise<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; •&nbsp;&nbsp; &nbsp;Talent<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; •&nbsp;&nbsp; &nbsp;Client satisfaction<br><br></p>
      </b-card-text>
      <b-card-text>For More Information please visit our <b-link
          href="https://decorious.com/"
          target="_blank"
      >
       <b>Official Website</b>
      </b-link>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
  },
}
</script>

<style>

</style>
